import { forwardRef } from 'react'
import { Input as InputPrimitive } from '@base-ui/react/input'
import { cn } from '@/lib/utils'
import { useFieldControl } from './field-context'

const Input = forwardRef<HTMLInputElement, InputPrimitive.Props>(
  ({ className, ...props }, ref) => {
    const field = useFieldControl()
    return (
      <InputPrimitive
        ref={ref}
        id={props.id ?? field.id}
        aria-invalid={field.invalid || undefined}
        aria-describedby={field.errorId}
        data-slot="input"
        className={cn(
          'h-9 w-full min-w-0 rounded-lg border border-input bg-white px-3 py-1 text-sm text-foreground outline-none placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/20 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive',
          className,
        )}
        {...props}
      />
    )
  },
)
Input.displayName = 'Input'
export { Input }
